import httpManager from "../../shared/utils/httpManager";

export async function validateToken(token) {
  const url = "/customers/verify-token/";
  const response = await httpManager.post(url, { token }, { isPublic: true });
  return response.data;
}
